module.exports = __webpack_public_path__ + "static/media/fondo_inicio.f855a7bb.png";